import React from 'react'

import styles from './style.module.css'
import SideMenu from './NavigationMenu/SideMenu'
import BottomTabBar from './NavigationMenu/BottomTabBar'
import NoServicesBanner from '~components/NoServicesBanner'

interface Props {
    children: React.ReactNode
}

function Layout(props: Props) {
    return (
        <div className={styles.root}>
            <div className={styles.sidePanelContainer}>
                <SideMenu />
            </div>
            <div className={styles.bottomMenu}>
                <BottomTabBar />
            </div>
            <main className={styles.content}>
                <NoServicesBanner />
                {props.children}
            </main>
        </div>
    )
}

export default Layout
